export const env = {
	API_ENDPOINT_URL: process.env.REACT_APP_API_URL || '/api',
}
